<template>
	<v-app>
		<v-app-bar app>
			<v-toolbar class="white">
			<img alt="Vue logo" src="./assets/rexel.png" height="50">
				<v-toolbar-title class="indigo--text text--darken-2 ma-9" style="width: 200px;">
					Multi Energy
				</v-toolbar-title>
			</v-toolbar>
		</v-app-bar>
		<v-content class="white">
			<PageAccueil/>
		</v-content>
	</v-app>
</template>

<script src="/dist/vue-add-to-calendar.min.js"></script>
<script>
	import PageAccueil from './components/PageAccueil'

	export default {
		name: 'App',
		components: {
			PageAccueil,
		},
	};
</script>
